import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, of, skipWhile, Subject, switchMap} from 'rxjs';
import {environment} from '../environments/environment';
import { NativeEventSource, EventSourcePolyfill } from 'event-source-polyfill';
import {HttpClient} from '@angular/common/http';
import {filter, skip} from "rxjs/operators";
import UserService from "./user/user.service";

@Injectable()
export default class UpdateService {
  private topics = [
    'doings', 'events', 'tasks', 'notes', 'messages'
  ];

  private observables = {};

  private isInErrorState = false;

  private mercureSubject = new Subject<any>();
  private mercure$ = this.mercureSubject.asObservable();

  public constructor(private http: HttpClient, private user: UserService) {
    if(environment.mercureUrl) {
      const url = new URL(environment.mercureUrl);
      url.searchParams.append('topic', 'sse');
      const es = new EventSourcePolyfill(url.href, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('mercure_key')
        }
      });

      es.onmessage = (e: MessageEvent) => {
        console.log(e);
        this.mercureSubject.next(JSON.parse(e.data));
      };
      es.onerror = e => {
        console.error(e);
      };

    }
  }

  public subscribeToChanges<T>(model: string): Observable<{
    payload: T,
    status: 'created'|'updated'|'deleted',
    id?: any
  }> {

    if(Object.keys(this.observables).indexOf(model) >= 0) {
      return this.observables[model].pipe(skipWhile((m => m == null)));
    } else {
      return of(null);
    }
  }

  public broadcast(payload) {
    return of(true);
    this.http.post(environment.apiUrl + '/users/broadcast', payload).subscribe(
        result => {
          return;
        });
  }

  public send(topic: string, payload: any) {
    return this.http.post(environment.apiUrl + '/users/send-topic/' + topic, payload);
  }

  public subscribe<T>(topic?: string) {
    return this.mercureSubject
        .pipe(filter(e => {
          if(topic) {
            return (e as any).topic == topic;
          } else {
            return true;
          }
        }));
  }

  public windowBroadcast(payload) {
    return of(true);
    const deviceId = localStorage.getItem('deviceKey');
    this.http.post(environment.apiUrl + '/users/broadcast?deviceId=' + deviceId, payload).subscribe(
      result => {
        return;
    });
  }
}
